module.exports = __webpack_public_path__ + "img/star2red.ab5addad.png";